import type { OrderPricing } from '@/services/orders';
import { Card } from './Card';

interface PricingCardProps {
  readonly pricing: OrderPricing | null;
}

export const PricingCard = ({ pricing }: PricingCardProps) => (
  <Card>
    <div
      style={{
        fontSize: '14px',
        fontWeight: 'var(--font-weight-medium)',
        color: 'var(--text-primary)',
        marginBottom: '10px',
      }}
    >
      Pricing breakdown
    </div>

    {!pricing ? (
      <div style={{ fontSize: '13px', color: 'var(--text-tertiary)', fontStyle: 'italic' }}>
        No pricing data available
      </div>
    ) : (
      <div>
        <ProfitRow label="Subtotal" value={`$${pricing.subtotal.toFixed(2)}`} />
        <ProfitRow label="Setup fee" value={`$${pricing.setupFee.toFixed(2)}`} />
        <ProfitRow label="Shipping fee" value={`$${pricing.shippingCharge.toFixed(2)}`} />
        <ProfitRow label="Tax" value={`$${pricing.taxCharged.toFixed(2)}`} />
        {pricing.discountAmount > 0 && (
          <ProfitRow label="Discount" value={`-$${pricing.discountAmount.toFixed(2)}`} />
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '5px 0',
            fontSize: '13px',
            fontWeight: 'var(--font-weight-medium)',
            borderTop: '0.5px solid var(--border-default)',
            marginTop: '4px',
            paddingTop: '8px',
            color: 'var(--text-primary)',
          }}
        >
          <span>Total charged</span>
          <span>${pricing.totalCharged.toFixed(2)} {pricing.currency.toUpperCase()}</span>
        </div>
      </div>
    )}
  </Card>
);

const ProfitRow = ({
  label,
  value,
  valueColor,
}: {
  readonly label: string;
  readonly value: string;
  readonly valueColor?: string;
}) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '5px 0',
      fontSize: '13px',
    }}
  >
    <span style={{ color: 'var(--text-tertiary)' }}>{label}</span>
    <span style={{ color: valueColor ?? 'var(--text-primary)' }}>{value}</span>
  </div>
);
